import httpApi from '@/apis/httpApi';
import { request } from '@/apis/request';

// 全部直播列表
interface myGamesData {
  sub_uid?: string;
}

export interface gameListJson {
  box_game_id: number;
  download_ad: number;
  download_ios: number;
  download_pc: number;
  game_appid: number;
  game_logo_url: string;
  game_name: string;
  game_tags: string;
  game_time: number;
  game_version_name: string;
  ios_download_url: string;
  no_need_download: number;
  oper_name: string;
  pc_game_type: number;
}

export interface myGamesJson {
  game_list: gameListJson[];
}

export function myGames(data?: myGamesData) {
  return request<myGamesJson>({
    method: 'POST',
    url: httpApi.game.myGames,
    data
  });
}

export interface modalInfoJson {
  isModalVisible: boolean;
  isUpdate: boolean;
  gameName: string;
  gameId: number;
}

interface delLatelyGameData {
  box_game_id: number[];
}

export function delLatelyGame(data?: delLatelyGameData) {
  return request({
    method: 'POST',
    url: httpApi.game.delLatelyGame,
    data
  });
}

export interface aboutBoxModalJson {
  isModalVisible: boolean;
  isUpdate: boolean;
}

interface versionRequest {
  app_version: string;
}

interface versionResponse {}

// 新服详情
export function apiGetVersionInfo(data: versionRequest) {
  return request<versionResponse>({
    method: 'POST',
    url: httpApi.home.versionInfo,
    data
  });
}

/**
 * 专区显示状态：0关 1开
 * @param {number} [isShow] - 传3，可选。
 * @param {number} [isShowPurePcSwitch] - 传奇纯PC，可选。
 * @param {number} [isShowTanWanSwitch] - 贪玩，可选。
 * @param {string} [isZoneGameUrl] - 精品专区url，可选。
 * @param {string} [lsGameH5Url] - 梁山传奇url，可选。
 * @param {boolean} [enableIndependenceRexueGame] - 热江专区，可选。
 */
export interface PrefectureConfig {
  isShow?: number;
  isShowPurePcSwitch?: number;
  isShowTanWanSwitch?: number;
  isZoneGameUrl?: string;
  lsGameH5Url?: string;
  enableIndependenceRexueGame?: boolean;
}

export function apiGetShowPcPrefecture() {
  return request<PrefectureConfig>({
    method: 'GET',
    url: httpApi.home.getShowPcPrefecture
  });
}

export function getUserGameInfo() {
  return request<any>({
    method: 'GET',
    url: httpApi.user.getUserGameInfo
  });
}

// PC获取语音开播数据 - 刘阳
interface beginVoiceLiveDataJson {
  data_type: string;
  voice_room_id: string;
}

export function beginVoiceLiveData() {
  return request<beginVoiceLiveDataJson>({
    method: 'GET',
    url: httpApi.voice.beginVoiceLiveData
  });
}
